import React from 'react';
import BusinessCaseSummary from '../business-case-summary';

const BusinessCasesListView = (props) => {
  const { bcbCasesList, customClass, reducedView, hideEditButton, currentBusinessCase, isWidget = false } = props;
  const { setActiveBusinessCase } = props.actions;

  const contentLayout = (
    <ul className="list-group list-group-flush">
      {
        bcbCasesList.map((bcbItem, id) => (
          <li
            className={`list-group-item business-case-summary ${currentBusinessCase === bcbItem.bcbId ? 'active ' : ''}`}
            key={bcbItem.bcbId}
          >
            <BusinessCaseSummary
              businessCaseItem={bcbItem}
              id={id}
              onActivateBusinessCase={setActiveBusinessCase}
              currentBusinessCase={currentBusinessCase}
              customClass={`${customClass}`}
              reducedView={reducedView}
              hideEditButton={hideEditButton}
              isWidget={isWidget}
            />
          </li>
        ))
      }
    </ul>
  );

  return (
    <React.Fragment>
      {contentLayout}
    </React.Fragment>
  );
};

export default BusinessCasesListView;
